import { Observable } from 'rxjs';

export interface PaymentMethodPollingConfig {
  showVerificationPage: (url: string) => Observable<unknown>;
  proceed: () => Observable<unknown>;
  cancel: () => Observable<unknown>;
}
